import map from 'lodash/map'

import { Props as AnswerProps } from '../..'

const Matching = ({ answer }: AnswerProps) => {
  return (
    <ul>
      {map(answer, (subanswer, subquestion) => (
        <li key={subquestion}>
          {subquestion} -&gt; {subanswer}
        </li>
      ))}
    </ul>
  )
}

export default Matching
